export default "__VITE_ASSET__BvhD4CPY__"